import React, { useMemo, useEffect } from 'react';
import { Box } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { useSelector, useLocation } from 'umi';
import { useDispatch } from 'dva';
import {
  SelectFieldCom,
  TextFieldCom,
} from '../../../profile/label_manage/components/FormType';

export default ({
  control,
  setValue,
  errors,
  setError,
  clearErrors,
  watch,
  setFileList,
  setCanDownload,
}) => {
  const {
    qrParamsFormData,
    refreshQrParamsFormData,
    refreshPagePath,
    defaultFormData,
  } = useSelector((state) => state.voucherEdit);
  const dispatch = useDispatch();
  const location = useLocation();
  const { query } = location;
  const { queryType } = query;
  const miniProgramAccountList =
    useSelector((state) => state.addAutoReplyRule.miniProgramAccountList) || [];
  const watchStoresParam = watch('storeKey');
  const watchPagePath = 'page/index';
  // const watchStores = watch('stores');
  // const watchStoreKey = watch('storeKey');

  //生成唯一id
  function guid() {
    return Number(Math.random().toString().substr(3, 3) + Date.now()).toString(
      36,
    );
  }
  //点击添加一条小程序码参数
  const handleOperationParamData = (index, status) => {
    dispatch({
      type: 'voucherEdit/operationParamData',
      payload: {
        values: {
          index,
          status,
        },
      },
    });
  };
  //参数输入修改数据结果
  const handleInitEvent = (params) => {
    dispatch({
      type: 'voucherEdit/setParamData',
      payload: {
        values: params,
      },
    });
  };

  useEffect(() => {
    if (
      qrParamsFormData &&
      qrParamsFormData.length > 0 &&
      refreshQrParamsFormData
    ) {
      qrParamsFormData.map((item) => {
        setValue(`name_${item.id}`, item.name);
        setValue(`value_${item.id}`, item.value);
      });
    }
  }, [qrParamsFormData?.length, setValue, refreshQrParamsFormData]);
  const paramsStr = useMemo(() => {
    if (qrParamsFormData && qrParamsFormData.length > 0) {
      let params = '';
      qrParamsFormData.map((item, index) => {
        if (item.name && item.value) {
          if (index === 0) {
            params = item.name + '=' + item.value;
          } else {
            params += '&' + item.name + '=' + item.value;
          }
        }
      });
      return params;
    }
  }, [qrParamsFormData?.length, refreshPagePath, refreshQrParamsFormData]);
  useEffect(() => {
    if (defaultFormData) {
      // setValue('name', defaultFormData.name);
      setValue('appId', defaultFormData.appId);
      // setValue('pagePath', defaultFormData.pagePath);
      setValue('storeKey', defaultFormData.storeKey);
      defaultFormData.importUrl &&
        setFileList([
          {
            url: defaultFormData.importUrl,
            id: guid(),
            fileName: defaultFormData.importUrl,
          },
        ]);
      defaultFormData.importUrl && setValue('url', defaultFormData.importUrl);
    }
  }, [defaultFormData]);

  const storeStr = useMemo(() => {
    if (paramsStr) {
      return watchStoresParam ? '&' + watchStoresParam + '=XXX' : '';
    }
    return watchStoresParam ? '?' + watchStoresParam + '=XXX' : '';
  }, [watchStoresParam, paramsStr]);
  const clearArrayData = (params) => {
    dispatch({
      type: 'voucherEdit/clearOperationParamData',
      payload: {
        values: params,
      },
    });
  };
  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" marginBottom="24px" flexDirection="column">
        <Box width="320px" display="flex" alignItems="flex-end">
          <SelectFieldCom
            label="小程序"
            initLabel={true}
            placeholder="请选择小程序"
            name="appId"
            realName="operation"
            disabled={queryType === 'detail'}
            setValue={setValue}
            control={control}
            errors={errors}
            setError={setError}
            clearErrors={clearErrors}
            nameMessage=""
            typeList={miniProgramAccountList || []}
            fieldNames={{ label: 'nickName', value: 'appId' }}
            handleInitEvent={() => {
              setCanDownload(true);
            }}
          />
        </Box>
      </Box>
      <Box>
        {/* <Box
          sx={{
            color: '#212121',
            fontSize: '18px',
            fontWeight: '600',
          }}
        >
          小程序码参数
        </Box> */}
        <Box display="flex" flexDirection="column" gap="24px">
          {/* <Box width="320px">
            <TextFieldCom
              label="PagePath"
              control={control}
              name="pagePath"
              setValue={setValue}
              getValues={getValues}
              placeholder="请输入"
              rules={{
                required: true, //是否是必填项true 必填 false 非必填
                maxLength: 200,
                pattern: /^[a-zA-Z0-9_/]+$/,
              }}
              errors={errors}
              queryType={queryType}
              helperText="仅可输入英文、数字、下划线、和斜杠"
            />
          </Box> */}
          <Box display="flex" alignItems="center">
            <Box sx={{ color: '#333', fontSize: '16px', marginRight: '24px' }}>
              参加参数方式
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
            }}
          >
            <Box
              sx={{
                display: 'none',
                background: '#F9F9F9',
                borderRadius: '8px',
                padding: '12px 16px',
              }}
            >
              <span
                style={{
                  color: '#999999',
                  fontSize: '16px',
                  lineHeight: '20px',
                  marginRight: '8px',
                }}
              >
                预览
              </span>
              {
                <span
                  style={{
                    color: queryType !== 'detail' ? '#333333' : '#ccc',
                    fontSize: '14px',
                    wordBreak: 'break-all',
                  }}
                >
                  {watchPagePath || (
                    <span style={{ color: '#cccccc', fontSize: '14px' }}>
                      pagepath
                    </span>
                  )}
                  {paramsStr ? (
                    `?${paramsStr}`
                  ) : (
                    <span
                      style={{
                        color: '#ccc',
                        fontSize: '16px',
                        lineHeight: '22px',
                      }}
                    >
                      {storeStr ? '' : '?参数名称=参数内容&门店参数名称=XXXXX'}
                    </span>
                  )}
                  <span
                    style={{
                      color: queryType !== 'detail' ? '#333333' : '#ccc',
                      fontSize: '14px',
                    }}
                  >
                    {storeStr}
                  </span>
                </span>
              }
            </Box>
            <Box
              border=" 1px solid #CCCCCC"
              borderRadius="12px"
              // width="1096px"
              padding="25px 48px 24px 24px"
              display="flex"
              flexDirection="column"
              gap="25px 0"
            >
              {qrParamsFormData &&
                qrParamsFormData.length > 0 &&
                qrParamsFormData.map((item, index) => (
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    key={item.id}
                  >
                    <Box display="flex" gap="0 48px">
                      <Box width="420px">
                        <TextFieldCom
                          label="参数名称"
                          control={control}
                          name={`name_${item.id}`}
                          setValue={setValue}
                          placeholder="输入文本"
                          // defaultValue={item.name}
                          handleInitEvent={(v) => {
                            setCanDownload(true);
                            handleInitEvent({ index, key: 'name', value: v });
                          }}
                          clearArrayData={clearArrayData}
                          parameter={{
                            index,
                            key: 'name',
                          }}
                          queryType={index === 0 ? 'detail' : ''}
                          errors={errors}
                          rules={{
                            maxLength: 30,
                            pattern: /^[a-zA-Z0-9_]+$/,
                          }}
                          helperText="仅可输入英文、数字、下划线"
                        />
                      </Box>
                      <Box width="420px">
                        <TextFieldCom
                          label="参数内容"
                          control={control}
                          name={`value_${item.id}`}
                          setValue={setValue}
                          placeholder="输入文本"
                          // defaultValue={item.value}
                          handleInitEvent={(v) => {
                            setCanDownload(true);
                            handleInitEvent({ index, key: 'value', value: v });
                          }}
                          errors={errors}
                          clearArrayData={clearArrayData}
                          parameter={{
                            index,
                            key: 'value',
                          }}
                          queryType={index === 0 ? 'detail' : ''}
                          rules={{
                            maxLength: 30,
                            pattern: /^[a-zA-Z0-9_]+$/,
                          }}
                          helperText="仅可输入英文、数字、下划线"
                        />
                      </Box>
                    </Box>
                    <Box display="flex" gap="0 16px" alignItems="flex-end">
                      {qrParamsFormData?.length < 5 && (
                        <Box className="params-icon-wrap">
                          <AddIcon
                            width="100%"
                            height="100%"
                            htmlColor={
                              queryType === 'detail'
                                ? 'rgba(0, 0, 0, 0.38)'
                                : 'rgba(0, 0, 0, 0.87)'
                            }
                            onClick={() =>
                              queryType !== 'detail' &&
                              handleOperationParamData(index, '1')
                            }
                          />
                        </Box>
                      )}
                      {qrParamsFormData?.length > 1 && index !== 0 && (
                        <Box className="params-icon-wrap">
                          <RemoveIcon
                            width="100%"
                            height="100%"
                            htmlColor={
                              queryType === 'detail'
                                ? 'rgba(0, 0, 0, 0.38)'
                                : 'rgba(0, 0, 0, 0.87)'
                            }
                            onClick={() => {
                              setCanDownload(true);
                              queryType !== 'detail' &&
                                handleOperationParamData(index, '0');
                            }}
                          />
                        </Box>
                      )}
                    </Box>
                  </Box>
                ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
